import { Box, Heading } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';

const NAMES = [
  'estimates',
  'visualizations',
  'privacy protection',
  'collaboration',
];

const BetterSectionHeader = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  useEffect(() => {
    const unsub = setInterval(() => {
      setCurrentIndex(prv => (prv + 1 >= NAMES.length ? 0 : prv + 1));
    }, 1000);

    return () => clearInterval(unsub);
  }, []);

  return (
    <Box d="flex" alignItems="center" mb={{ base: 0, tablet: '80px' }}>
      <Heading style={{ marginBottom: 0 }} size={{ base: 500, tablet: 700 }}>
        Better &nbsp;
      </Heading>
      <Heading style={{ marginBottom: 0 }} size={{ base: 500, tablet: 700 }}>
        {NAMES[currentIndex]}
      </Heading>
    </Box>
  );
};

export default BetterSectionHeader;
